import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_BEGIN,
  REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_SUCCESS,
  REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_FAILURE,
  REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchOosReportByOrderNumber(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getOosReportByItemNumber`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchOosReportByOrderNumberError() {
  return {
    type: REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_DISMISS_ERROR,
  };
}

export function useFetchOosReportByOrderNumber() {
  const dispatch = useDispatch();

  const { reportsCustomerData, reportsCustomerTotals, customerSummary,fetchOosReportByOrderNumberPending, fetchOosReportByOrderNumberError } = useSelector(
    state => ({
      reportsCustomerData: state.reports.reportsCustomerData,
      reportsCustomerTotals: state.reports.reportsCustomerTotals,
      customerSummary: state.reports.customerSummary,
      fetchOosReportByOrderNumberPending: state.reports.fetchOosReportByOrderNumberPending,
      fetchOosReportByOrderNumberError: state.reports.fetchOosReportByOrderNumberError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchOosReportByOrderNumber(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchOosReportByOrderNumberError());
  }, [dispatch]);

  return {
    reportsCustomerData,
    reportsCustomerTotals,
    customerSummary,
    fetchOosReportByOrderNumber: boundAction,
    fetchOosReportByOrderNumberPending,
    fetchOosReportByOrderNumberError,
    dismissFetchOosReportByOrderNumberError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchOosReportByOrderNumberPending: true,
        fetchOosReportByOrderNumberError: null,
      };

    case REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchOosReportByOrderNumberPending: false,
        fetchOosReportByOrderNumberError: null,
        reportsCustomerData: action.data.data,
        reportsCustomerTotals: action.data.totals,
        customerSummary: action.data.summary,
      };

    case REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchOosReportByOrderNumberPending: false,
        fetchOosReportByOrderNumberError: action.data.error,
      };

    case REPORTS_FETCH_OOS_REPORT_BY_ORDER_NUMBER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchOosReportByOrderNumberError: null,
      };

    default:
      return state;
  }
}
